import { createSlice } from "@reduxjs/toolkit";

const data = {
    tiposDocumentos: [{ id: 0, descripcion: "" }],
    personaDocumentos: [{
        id: 0,
        idPersona: 0,
        numero: 0,
        idTipoDocumento: 0,
        tipoDocumento: "",
        numeroDocumento: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    }],
    validationActive: {
        AtLeastOneDocument: false,
        OnlyOneTypeDocument: false,
        DNIWith8Digits: false,
        RUCWith11Digits: false,
        AnyDocumentAtLeast3Digits: false,
        DocumentAlReadyExists: false
    },
    validationMessage: [],
}

export const personDocumentSlice = createSlice({
    name: "personDocument",
    initialState: {},
    reducers: {
      initPersonDocument: (state, action) => {
        const { sliceKey } = action.payload;
        if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      },
      setTiposDocumentos: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].tiposDocumentos = data;
      },
      setPersonaDocumentos: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].personaDocumentos = data;
      },
      setDatoPersonaDocumento: (state, action) => {
        var { sliceKey, numero, name, value } = action.payload;

        if (name.startsWith("id")) value = parseInt(value)

        const index = state[sliceKey].personaDocumentos.findIndex(item => item.numero === numero);
        state[sliceKey].personaDocumentos[index][name] = value;

        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
            state[sliceKey].validationActive[key] = true;
        })
      },
      addPersonaDocumento: (state, action) => {
        const sliceKey = action.payload;
        var maxNumero = state[sliceKey].personaDocumentos?.length === 0 ? 0 : Math.max.apply(null, state[sliceKey].personaDocumentos?.map((item) => { return item.numero; }))

        state[sliceKey].personaDocumentos?.push(defaultPersonaDocumentos.map((item) => { return { ...item, numero: maxNumero + 1 } })[0]);
        state[sliceKey].validationActive.OnlyOneTypeDocument = true
      },
      removePersonaDocumento: (state, action) => {
        const {sliceKey, numero} = action.payload;
        state[sliceKey].personaDocumentos = state[sliceKey].personaDocumentos.filter(item => item.numero !== numero)
        state[sliceKey].validationActive.AtLeastOneDocument = true
      },
      setValidations: (state, action) => {
        const {sliceKey, message} = action.payload;
        if (JSON.stringify(state[sliceKey].validationMessage) !== JSON.stringify(message)) {
            state[sliceKey].validationMessage = message;
        }
        // state[sliceKey].validationMessage = message;
      },
      activeValidationsPersonaDocumento: (state, action) => {
        const {sliceKey} = action.payload;
        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
            state[sliceKey].validationActive[key] = true;
        })
      },
    },
  });
  
  export const { initPersonDocument, setTiposDocumentos, setPersonaDocumentos, setDatoPersonaDocumento
    , addPersonaDocumento, removePersonaDocumento, setValidations, activeValidationsPersonaDocumento } = personDocumentSlice.actions;
  export const defaultPersonaDocumentos = [{
      id: 0,
      idPersona: 0,
      numero: 0,
      idTipoDocumento: 6,
      tipoDocumento: "DNI",
      numeroDocumento: "",
      fechaRegistro: null,
      usuarioRegistro: null,
      fechaModificacion: null,
      usuarioModificacion: null,
  }]
  export const defaultPersonaJuridicaDocumentos = [{
      id: 0,
      idPersona: 0,
      numero: 0,
      idTipoDocumento: 7,
      tipoDocumento: "RUC",
      numeroDocumento: "",
      fechaRegistro: null,
      usuarioRegistro: null,
      fechaModificacion: null,
      usuarioModificacion: null,
  }]
  export default personDocumentSlice.reducer;
  